// Globals
import { useTranslation } from 'react-i18next';

// Modules
import { ImagesUploaderContainer } from '@/modules/Upload';

// Components
import { StyledButton, StyledContainer } from './FloorPlanStyles';

// Models
import { FileVariant, IFile } from '@/models/file.model';
import { IOrder, OrderStatus } from '@/models/order.model';

// Helpers
import { ACCEPT_IMAGE_FILE_TYPES, MAX_IMAGE_SIZE } from '../../helpers';

type TFloorPlan = {
  order: IOrder;
  onUploadFile: (filesList: File[], type: FileVariant) => void;
  onDelete: (file: IFile) => void;
};

const FloorPlan = ({ order, onDelete, onUploadFile }: TFloorPlan) => {
  const { t } = useTranslation('order');
  const handleUpload = (_file: File, filesList: File[]) => onUploadFile(filesList, FileVariant.FLOOR_PLAN);

  return (
    <StyledContainer>
      <ImagesUploaderContainer
        acceptance={ACCEPT_IMAGE_FILE_TYPES}
        onChange={handleUpload}
        description={t('upload_floor_plan')}
        disabled={order.status !== OrderStatus.IN_PROGRESS}
        imagesList={order?.appraisal?.floor_plan}
        maxImageSize={MAX_IMAGE_SIZE}
        multiple
        onDelete={onDelete}
      >
        <StyledButton shape="round">{t('upload', { ns: 'common' })}</StyledButton>
      </ImagesUploaderContainer>
    </StyledContainer>
  );
};

export default FloorPlan;
